
import { takeEvery } from '@zaibot/fsa-saga';
import 'arrayq';
import { selectors as metaSelectors } from '../meta/selectors';
import { delay, fork, put, select } from '../redux-saga';
import { beheerResource, beheerEditor, beheerBatch } from './resource';

import AUTHENTICATED from '../auth/actions/AUTHENTICATED';
import LOGGEDOUT from '../auth/actions/LOGGEDOUT';
import { IAdmin } from '../types';
import { RaceEffect, SelectEffect, TakeEffect, call, race, take } from 'redux-saga/effects';
import ADMIN_CREATE from './actions/ADMIN_CREATE';
import ADMIN_UPDATE from './actions/ADMIN_UPDATE';
import ADMIN_INIT from './actions/ADMIN_INIT';

export function* rootSaga(): Iterable<any> {
    yield fork(beheerResource.saga);
    yield fork(beheerEditor.saga);
    yield fork(beheerBatch.saga);
    yield fork(signalcreatebeheer);
    yield fork(signalupdatebeheer);
    yield fork(signallistbeheer);
    yield fork(signalBeheerReadWhenAuthenticated);
    yield fork(signalBeheerReset);     
}

function* signalcreatebeheer() {
    yield takeEvery([
            ADMIN_CREATE,
        ], function*(action) {
        if (action.payload.item) {         

            try {
                yield put(beheerResource.actions.CREATE({ item: beheerResource.create(action.payload.item) as IAdmin }));
            } catch (error) {
                // tslint:disable-next-line
                console.log('Admin couldn\'t be backed up');
                yield put(beheerEditor.actions.CREATE_CANCEL({ item: action.payload.item as IAdmin }));
                yield put(ADMIN_INIT({item: action.payload.item as IAdmin, busy: false}));    
            }  
        }
    });   
}

function* signalupdatebeheer() {
    yield takeEvery([
            ADMIN_UPDATE,
        ], function*(action) {
        
        const raceWaitTime = 5000;
            
        if (action.payload.item) {     
            try {    
                yield put(beheerEditor.actions.UPDATE({ item: action.payload.item as IAdmin }));            
                const waiting: RaceEffect = yield race({
                    timeout: call(delay, raceWaitTime),
                    updateend: take([beheerResource.actions.UPDATE]),
                });   
                let waitresult: any = waiting;                
                if (waitresult.updateend) {
                    yield put(beheerEditor.actions.UPDATE_CONTINUE({ item: action.payload.item as IAdmin }));                
                } else {
                    // tslint:disable-next-line
                    console.log('Admin couldn\'t be backed up');
                }
            } catch (error) {
                // tslint:disable-next-line
                console.log('Admin couldn\'t be backed up');
                yield put(beheerEditor.actions.UPDATE_CANCEL({ item: action.payload.item as IAdmin }));
                yield put(ADMIN_INIT({item: action.payload.item as IAdmin, busy: false}));    
            } 
        }
    });   
}

function* signallistbeheer() {
    yield takeEvery<any, any>([
        beheerResource.actions.LIST_SUCCESS,
        beheerResource.actions.LIST_FAILURE,
        beheerResource.actions.CREATE_SUCCESS,
        beheerResource.actions.UPDATE_SUCCESS,
        beheerResource.actions.DELETE_SUCCESS,
    ], function*() {
        const beheer: IAdmin[] = yield select(beheerResource.selectors.items);
        const documentIdEff: TakeEffect = yield select(metaSelectors.docId);
        const documentId: any = documentIdEff;
        const current = beheer.qWhere((x) => x.documentId === documentId).qFirst();
        if (current) {            
            yield put(beheerResource.actions.READ({ item: current }));  
            yield put(ADMIN_INIT({item: current, busy: false}));
        } else {
            yield put(ADMIN_INIT({item: undefined, busy: false}));
        }
    });
}

function* signalBeheerReadWhenAuthenticated() {
    yield takeEvery(AUTHENTICATED, function*() {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        yield put(beheerResource.actions.LIST({ params: { selectionDocumentId } })); 
    });
}

function* signalBeheerReset() {
    yield takeEvery(LOGGEDOUT, function*() {
        yield put(beheerResource.actions.RESET({ }));
        yield put(ADMIN_INIT({item: undefined, busy: false}));
        yield put(beheerEditor.actions.RESET({ })); 
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/admin/sagas.tsx